import { IPaginatedResponse } from "./api-base-actions.interface";

export interface VehicleStatus {
  reg: string;
  model: string;
  status: string;
  vorReason: string;
  changeDate: string;
  lastKnownLocation: string;
}


export interface IVehicleUtilisationSnapshot {
  id: number
  vehicle: IUtilisationVehicle
  snapshot_date: string
  last_updated_at: string
  is_vor: boolean
  comment: string
  is_utilized: boolean
  manually_marked_as_utilized: boolean
  last_utilization_change_reason: string
  last_utilization_change_datetime: any
  depot: number
  region: number
  last_entered_geofence: any
  vehicle_registration_field?: string
}

export interface IUtilisationVehicle {
  id: number
  registration: string
  model_name: string
  manufacturer_name: string
  vehicle_type_name: string
  driver_category_name: string
}
export interface IUtilisationSnapshotResponse extends IPaginatedResponse {
  results: IVehicleUtilisationSnapshot[]
}

export interface IUtilisationDepot {
  available_count: number
  not_available_count: number;
  snapshot_date: string
  total_count: number;
  unutilized_count: number;
  utilized_count: number;
}

export interface IUtilisationStatisticsResponse {
  [key: string]: IUtilisationDepot
}

export enum IQueryFilterRange {
  ThisYear = "1",
  ThisMonth = "2",
  PrevMonth = "3",
  Today = "4",
  Yesterday = "5",
  ThisWeek = "6",
}

export interface IQueryFilterOptions {
  range: IQueryFilterRange
}

export interface RangeFilterOption {
  value: IQueryFilterRange
  label: string;
}
export interface IUtilisationEvent {
  id: number
  reference_object_type: string
  created_at: string
  reference_object_id: string
  notes: string
  metadata: IUtilisationEventMetadata
  utilization_change_type: number
  utilization_snapshot: number
}

export interface IUtilisationEventResponse extends IPaginatedResponse {
  results: IUtilisationEvent[]
}

export interface IUtilisationEventMetadata {
  type?: string
  report_class?: string
  id?: number
  uuid?: string
  depot?: number
  status?: number
  defect_number?: string
  _current_vor_activities: string
}

export interface IVOREventDetails {
  description: string;
  status_display: string;
  record_id: string;
  status: string;
}

export interface IUtilizationVOREvent {
  activity_class: string;
  activity_type: string;
  activity_id: string;
  details?: IVOREventDetails | null;
}

export interface IVehicleActivityDetail {
  id: number;
  description: string;
  created_at: string;
  status: string;
  record_id: string;
  archived: boolean;
  trigger_status_name: string;
}

export interface IScheduledActivityDetail {
  id: number
  schedule_type_name: string;
  status: string;
  status_display: string,
  notes: string | null;
}

export interface IEventExceptionReasons {
  id: number
  reference: string
  display_name: string
}

export enum UtilisationChangeTypes {
  // UTILIZED = 0, "Utilized";
  // UNUTILIZED = 1, "Unutilized";
  // NO_CHANGE = 2, "No-Change";
  UTILIZED = "Used", // 0
  UNUTILIZED = "Unused", // 1
  NO_CHANGE = "No-Change", // 2
  UNVOR = "Available (UnVOR)", // 3
}

export enum ReferenceObjectTypes {
  // DEFECT = "DF", "Defect"
  // SAFETY_INSPECTION = "SI", "Safety Inspection"
  // VEHICLE_CHECK = "VC", "Vehicle Check"
  // TRIGGER_EVENT = "TE", "Trigger Event"
  // VEHICLE_ACTIVITY = "VA", "Vehicle Activity"
  // # This is partially for users to be able to add
  // # Custom events and for carrying over the
  // # previous day's status to the coming day
  // MANUAL = "MN", "Manual"
  DEFECT = 'Defect',
  SAFETY_INSPECTION = 'Safety Inspection',
  VEHICLE_CHECK = 'Vehicle Check',
  TRIGGER_EVENT = 'Trigger Event',
  VEHICLE_ACTIVITY = 'Vehicle Activity',
  MANUAL = 'Manual'
}

